import React, { useState, useEffect } from 'react'

import i18n from 'live/services/i18n'
import TableForm from 'live/components/forms/ui/TableForm'

const fields = [
    {
        name: 'key',
        label: i18n('Channel'),
        type: 'text'
    },
    {
        name: 'value',
        label: i18n('Unit'),
        type: 'text'
    }
]

export type UnitManagementFormProps = {
    caller: any
    dataObject: object
}

export type KVType = {
    key: string
    value: string
}
export type ToDataResult = {
    errMsg: string | null
    data: object | null
}

const UnitManagementForm: React.FC<UnitManagementFormProps> = ({ caller, dataObject }: UnitManagementFormProps) => {
    const [data, setData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')

    useEffect(() => {
        setData(fromData(dataObject))
    }, [dataObject])

    // Appends {key, value} to data. Return null if key is empty or key exists
    // dest: object array, src: array => object
    function toData(src: Array<KVType>): ToDataResult {
        const dest = {}
        const toDataResult: ToDataResult = {
            errMsg: null,
            data: null
        }

        src.forEach((value, index) => {
            const k = value.key.trim()
            if (k.length > 0) {
                if (dest[k] === undefined) {
                    const v = value.value.trim()
                    if (v.length > 0) {
                        dest[k] = v
                    } else {
                        toDataResult.errMsg = 'Empty unit value at key ' + k + ' line: ' + (index + 1).toString()

                        return toDataResult
                    }
                } else {
                    toDataResult.errMsg = 'Line: ' + (index + 1).toString() + '. Key ' + k + ' already exists'

                    return toDataResult
                }
            } else {
                toDataResult.errMsg = 'Empty key ' + k + ' line: ' + (index + 1).toString()

                return toDataResult
            }
        })

        toDataResult.data = dest

        return toDataResult
    }

    // From service. It MUST be validated
    // JSON object to JSON array
    function fromData(data: any): any {
        const type = typeof data
        if (type === 'object') {
            if (Array.isArray(data)) {
                setErrorMsg('fromData: Was expected JSON object, but found Array')

                return []
            }

            const list = []
            Object.keys(data).forEach((key: string) => {
                if (key.length > 0) {
                    const value = data[key]
                    const valueType = typeof value
                    if (valueType === 'string') {
                        list.push({
                            key: key,
                            value: value
                        })
                    } else {
                        setErrorMsg(
                            'fromData: UnitManagementForm. Wrong schema type. Expected string but found ' + valueType
                        )

                        return []
                    }
                }
            })

            return list
        } else if (type === 'undefined') {
            return []
        }

        setErrorMsg('fromData: Not an object at UnitManagementForm. Found: ' + typeof data)

        return []
    }

    function onChangeObject(e: any) {
        setData(e)
        const result: ToDataResult = toData(e)
        caller(result)
        if (result.errMsg == null) setErrorMsg('')
        else setErrorMsg(result.errMsg)
    }

    return (
        <div>
            <TableForm
                data={data}
                fields={fields}
                onChange={(e: any) => {
                    onChangeObject(e)
                }}
            />
            <p style={{ color: 'red' }}>{errorMsg}</p>
        </div>
    )
}

export default UnitManagementForm
